module.exports = __webpack_public_path__ + "static/media/tailwind.dfa8abae.svg";